import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { useMap } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';

const MIN_ZOOM = 3;
const MAX_ZOOM = 18;

const TrackingMapZoom = () => {
  const map = useMap();
  const [zoom, setZoom] = useState(map?.getZoom());

  const handleZoom = (direction: 'in' | 'out') => {
    if (zoom) {
      setZoom(direction === 'in' ? zoom + 1 : zoom - 1);
      map?.setZoom(direction === 'in' ? zoom + 1 : zoom - 1);
    }
  };

  useEffect(() => {
    if (map) {
      const listener = map.addListener('zoom_changed', () => {
        const newZoom = map.getZoom();
        setZoom(newZoom);
      });

      return () => {
        google.maps.event.removeListener(listener);
      };
    }
  }, [map]);

  return (
    <div className='flex flex-col shadow-sm'>
      <Button
        onClick={() => handleZoom('in')}
        disabled={zoom === MAX_ZOOM}
        variant='outlined'
        size='sm'
        color='default'
        icon={<Icon name='plus' />}
        aria-label='Zoom in'
        className='rounded-b-none border-b-0 bg-white'
      />
      <Button
        onClick={() => handleZoom('out')}
        disabled={zoom === MIN_ZOOM}
        variant='outlined'
        size='sm'
        color='default'
        icon={<Icon name='minus' />}
        aria-label='Zoom out'
        className='rounded-t-none bg-white'
      />
    </div>
  );
};

export default TrackingMapZoom;
export { MIN_ZOOM, MAX_ZOOM };
